export const getLCComprehensionItem = (state, passageHalfIndex, questionIndex) => state.comprehensionItems[passageHalfIndex][questionIndex];

export const getNumLCComprehensionItems = (state, passageHalfIndex) => state.comprehensionItems[passageHalfIndex].length;

export const getCurrentLCContent = (state, passageHalfIndex) => state.content[passageHalfIndex];
